module.exports = __webpack_public_path__ + "img/line6.04f6d7ac.svg";